// Fase 1: Cargar configuración local (ej. desde storage o config file)
export const INIT_CONFIG_REQUEST = 'tego-server/INIT_CONFIG_REQUEST';
export const INIT_CONFIG_SUCCESS = 'tego-server/INIT_CONFIG_SUCCESS';
export const INIT_CONFIG_FAILURE = 'tego-server/INIT_CONFIG_FAILURE';
